var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.2842 2.20033C26.5708 0.823708 24.3943 0 22.0254 0H10.0254C4.50254 0 0.0253906 4.47715 0.0253906 10V22C0.0253906 27.5228 4.50254 32 10.0254 32H22.0254C27.5482 32 32.0254 27.5228 32.0254 22V12.6012L29.0254 15.6012V22C29.0254 25.866 25.8914 29 22.0254 29H10.0254C6.1594 29 3.02539 25.866 3.02539 22V10C3.02539 6.13401 6.1594 3 10.0254 3H22.0254C23.5652 3 24.9889 3.49719 26.1447 4.33979L28.2842 2.20033Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0254 17.8361L15.1473 23L30.0254 8",
    stroke: "#D42E79",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecked);
export default __webpack_public_path__ + "static/media/checked.11a93e913aa19bbf3673991197eaeeb7.svg";
export { ForwardRef as ReactComponent };